import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { IconClose } from 'assets/icons'
import { useCountDown } from 'hooks'
import { IconLock } from 'pages/manager-whiteboard/assets'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const FormLoginWith2FA = ({
    handleConfirmCode,
    isLoading,
    waitTime,
    setWaitTime
}) => {
    const { t } = useTranslation()
    const { register, handleSubmit, watch, setValue, formState: { errors, isValid }, trigger, setFocus } = useForm({ mode: "onChange" })
    const { secondsLeft, isRunning, start } = useCountDown({ initialSeconds: 0 });

    const info = watch("backup") ? { labelKey: 'multiFactor.labelCodeBackup', placeholderKey: 'multiFactor.placeholderCodeBackup', errorKey: 'validate.code2faBackupRequired' } :
        { labelKey: 'multiFactor.labelCode2fa', placeholderKey: 'multiFactor.placeholderCode2fa', errorKey: 'validate.code2faRequired' }

    useEffect(() => {
        if (waitTime > 0) start(waitTime);
        if (secondsLeft === 0) setWaitTime(0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [waitTime, secondsLeft]);

    return (
        <form onSubmit={handleSubmit(handleConfirmCode)}>
            <FormControlLabel labelPlacement='top' required label={t(info.labelKey)} control={
                <TextField autoFocus {...register("code", {
                    required: info.errorKey,
                    maxLength: { value: 100, message: "validate.maxLengthText" },
                    setValueAs: (value) => (value ? value?.trim() : "")
                })}
                    error={!!errors.code} helperText={errors.code ? t(errors.code.message, { num: 100 }) : ""} onBlur={(e) => {
                        const trimmed = e.target.value?.trim();
                        setValue("code", trimmed, { shouldValidate: true, shouldDirty: true });
                    }}
                    fullWidth placeholder={t(info.placeholderKey)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconLock />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                {watch("code") && <IconButton
                                    tabIndex={-1}
                                    aria-label="Clear input"
                                    onClick={() => setValue("code", '')}
                                    sx={{ p: 0.5 }}
                                >
                                    <IconClose />
                                </IconButton>}
                            </InputAdornment>
                        ),
                    }} />
            } />
            <Typography sx={{ fontStyle: 'italic', mt: 1 }}>{t('multiFactor.descCode2fa')}</Typography>
            <FormControlLabel sx={{ mt: 2, width: '100%' }} labelPlacement='end' label={t('multiFactor.labelUseBackupCode')} control={
                <Checkbox {...register("backup")} onChange={(e) => {
                    const checked = e.target.checked;
                    setValue("backup", checked);
                    setValue("code", "");
                    setTimeout(() => {
                        trigger("code")
                        setFocus("code")
                    }, 100)
                }} />
            } />
            {isRunning && <Typography>{t('multiFactor.timeoutEnterCode', { waitTime: secondsLeft })}</Typography>}
            <Button id='bnt-confirm-2fa' type='submit' fullWidth disabled={!isValid || isLoading || isRunning || !watch("code")} sx={{ mt: 2 }}>{t('actions.confirmCode')}</Button>
        </form>
    )
}

export default FormLoginWith2FA